import React, { type ReactNode } from 'react';

const buildsEnhancedMarkdownOverrides = {
  p: ParagraphThatIsHiddenOnCompact,
};

export function ParagraphThatIsHiddenOnCompact({
  children,
}: {
  children: ReactNode;
}) {
  return <p className={'hide-on-compact'}>{children}</p>;
}
ParagraphThatIsHiddenOnCompact.isParagraph = true;

export default buildsEnhancedMarkdownOverrides;
